import * as React from 'react';
import {useLoaderData, useNavigate} from "react-router-dom";
import logo from '../assets/logo.jpg'
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {useEffect} from "react";

export default function Score() {
    const game = useLoaderData();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            <Typography variant={'h5'} color="primary">
                Votre score
            </Typography>
            <Typography variant={'h1'} color="text.primary">
                {game.score}
            </Typography>
            <img src={logo} alt={'logo'} width={400}/>
        </>
    );
}
